module.exports = __webpack_public_path__ + "img/primary.0bf7e854.svg";